// extracted by mini-css-extract-plugin
export default {"navMenu":"test_navMenu__IzvDl","logo":"test_logo__mLWst"};